import { OnInit, Component, Input, inject } from "@angular/core";
import { TabService } from "@services/tabs/TabService";
import { Pages } from "@constants/pages/Pages";
import { NotificationService } from "@app/mailmessages/service/notification.service";
import { NotificationModel } from "@app/mailmessages/models/notificationModel";
import { GenericListConfig } from "@app/shared/models/GenericList/GenericList";
import { GenericListFieldType } from "@app/shared/models/GenericList/GenericListField";
import { ModuleType } from "@enums/ModuleType";
import { GenericListManagerComponent } from "@app/shared/generic-managers/generic-list-manager/generic-list-manager.component";
import { injectTranslation } from "@app/shared/i18n/translation-scope";
import { scope } from "@app/mailmessages/i18n/scope";

@Component({
    selector: "uc-notification-overview",
    templateUrl: "./notification-overview.component.html",
    styleUrls: ["./notification-overview.component.scss"],
    imports: [GenericListManagerComponent],
})
export class NotificationOverviewComponent implements OnInit {
    private _tabService = inject(TabService);
    private _mmService = inject(NotificationService);
    private _translation = injectTranslation(scope);
    pages = inject(Pages);

    @Input() module: ModuleType;

    config: GenericListConfig;

    // Await the scope before the synchronous t() calls in setupConfig().
    async ngOnInit() {
        await this._translation.ready();
        this._mmService.getNotifications(this.module).subscribe((data) => {
            this.setupConfig(data);
        });
    }

    setupConfig(data: NotificationModel[]) {
        this.config = <GenericListConfig>{
            name: this._translation.t("notificationOverview.listName"),
            data: data,
            idProp: "id",

            allowAdd: true,
            allowEdit: true,
            allowDelete: false,

            fields: [
                {
                    fieldName: "name",
                    prettyName: this._translation.t("notificationOverview.nameField"),
                    fieldType: GenericListFieldType.Text,
                    isReadonly: true,
                },
                {
                    fieldName: "subject",
                    prettyName: this._translation.t("notificationOverview.subjectField"),
                    fieldType: GenericListFieldType.Text,
                },
                {
                    fieldName: "active",
                    prettyName: this._translation.t("notificationOverview.sendActiveField"),
                    fieldType: GenericListFieldType.CheckBox,
                },
            ],
            addOverride: () => {
                const config = {
                    module: this.module,
                };
                this._tabService.generateTab(
                    this.pages.NotificationDetail,
                    0,
                    this._translation.t("notificationOverview.newNotificationTab"),
                    config
                );
            },
            editOverride: (row: NotificationModel) => {
                const config = {
                    module: this.module,
                };
                this._tabService.generateTab(
                    this.pages.NotificationDetail,
                    row.id,
                    row.name,
                    config
                );
            },
        };
    }

    openNotification(item: NotificationModel) {
        const config = {
            module: this.module,
        };
        this._tabService.generateTab(this.pages.NotificationDetail, item.id, item.name, config);
    }

    add() {
        const config = {
            module: this.module,
        };
        this._tabService.generateTab(
            this.pages.NotificationDetail,
            0,
            this._translation.t("notificationOverview.newNotificationTab"),
            config
        );
    }
}
